import * as constants from '@/common/constants';

export default {
    state: {
        userInfo: {}
    },
    mutations: {
        [constants.VUEX_MUTATIONS_USER_INFO]: (state, userInfo) => {
            state.userInfo = userInfo;
        }
    },
    actions: {
        [constants.VUEX_ACTIONS_USER_INFO] ({ commit }, userData) {
            commit(constants.VUEX_MUTATIONS_USER_INFO, userData);
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/store-user.js